var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportTemplate',{attrs:{"loading":!_vm.initialized,"title":"Inventory Last Received Report","permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_ON_HAND,"filters":_vm.filters,"columns":_vm.columns,"fetchRoute":"/reports/inventory-last-received","reportTypeCode":_vm.REPORT_MASTER_CODES.INVENTORY_ON_HAND}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }